import * as Sentry from "@sentry/react";
import React from "react";

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <Sentry.ErrorBoundary>{children}</Sentry.ErrorBoundary>;
};
